var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8DView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12813",
    "data-name": "Rectangle 12813",
    width: 60,
    height: 60,
    transform: "translate(1851 1245.326)",
    fill: "#78879b",
    stroke: "#89949b",
    strokeWidth: 1,
    opacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1351",
    "data-name": "Mask Group 1351",
    transform: "translate(-1851 -1245.326)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(1856.156 1245.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14502",
    "data-name": "Group 14502",
    transform: "translate(2.227 2.344)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21309",
    "data-name": "Path 21309",
    d: "M10.1,44.537V12.652A11.7,11.7,0,0,1,21.787.937H14.672A11.719,11.719,0,0,0,2.953,12.656V44.532A11.719,11.719,0,0,0,14.672,56.251h7.115A11.7,11.7,0,0,1,10.1,44.537Z",
    transform: "translate(-2.953 -0.937)",
    fill: "#78879b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14504",
    "data-name": "Group 14504",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21310",
    "data-name": "Path 21310",
    d: "M37.691,60H16.123a14.076,14.076,0,0,1-14.06-14.06V14.06A14.076,14.076,0,0,1,16.123,0H37.69a14.076,14.076,0,0,1,14.06,14.06v31.88A14.076,14.076,0,0,1,37.691,60ZM16.123,4.688A9.383,9.383,0,0,0,6.75,14.06v31.88a9.383,9.383,0,0,0,9.373,9.373H37.69a9.383,9.383,0,0,0,9.373-9.373V14.06a9.383,9.383,0,0,0-9.373-9.373Z",
    transform: "translate(-2.062 0)",
    fill: "#78879b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14505",
    "data-name": "Group 14505",
    transform: "translate(25.664 9.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21311",
    "data-name": "Path 21311",
    d: "M24.516,18.281H20.531a8.213,8.213,0,0,1-8.2-8.2V6.094a2.344,2.344,0,0,1,4.688,0v3.984a3.52,3.52,0,0,0,3.516,3.516h3.984a2.344,2.344,0,0,1,0,4.688Z",
    transform: "translate(-12.328 -3.75)",
    fill: "#78879b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14508",
    "data-name": "Group 14508",
    transform: "translate(13.477 21.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14503",
    "data-name": "Group 14503",
    transform: "translate(0.352)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_709",
    "data-name": "Ellipse 709",
    cx: 2.93,
    cy: 2.93,
    r: 2.93,
    fill: "#78879b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14506",
    "data-name": "Group 14506",
    transform: "translate(0 19.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21312",
    "data-name": "Path 21312",
    d: "M25.969,21.328H9.8a2.344,2.344,0,1,1,0-4.688H25.969a2.344,2.344,0,1,1,0,4.688Z",
    transform: "translate(-7.453 -16.641)",
    fill: "#78879b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14507",
    "data-name": "Group 14507",
    transform: "translate(0 10.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21313",
    "data-name": "Path 21313",
    d: "M25.969,17.719H9.8a2.344,2.344,0,1,1,0-4.688H25.969a2.344,2.344,0,1,1,0,4.688Z",
    transform: "translate(-7.453 -13.031)",
    fill: "#78879b"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8DView);
export default __webpack_public_path__ + "static/media/8D_view.1972a0b7dac5dcb9860ac59e6700f143.svg";
export { ForwardRef as ReactComponent };